const css = `.vuiScreenBlock {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vuiScreenBlock__mask {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}

.vrsModalWrapper {
  position: fixed;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL1VzZXJzL2NqL0RvY3VtZW50cy9HaXQvVmVjdGFyYS9yZWFjdC1zZWFyY2gvc3JjIiwic291cmNlcyI6WyJ2dWkvY29tcG9uZW50cy9zY3JlZW5CbG9jay9faW5kZXguc2NzcyIsInZ1aS9zdHlsZVV0aWxzL19kZXB0aC5zY3NzIiwiZ2xvYmFscy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBLFNDSmtCO0VES2xCO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7OztBRVhGO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIudnVpU2NyZWVuQmxvY2sge1xuICBwb3NpdGlvbjogZml4ZWQ7XG4gIHRvcDogMDtcbiAgbGVmdDogMDtcbiAgcmlnaHQ6IDA7XG4gIGJvdHRvbTogMDtcbiAgei1pbmRleDogJHNjcmVlbkJsb2NrWkluZGV4O1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbn1cblxuLnZ1aVNjcmVlbkJsb2NrX19tYXNrIHtcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogMTAwJTtcbiAgYmFja2dyb3VuZC1jb2xvcjogdHJhbnNwYXJlbnRpemUoJGNvbG9yRnVsbFNoYWRlLCAwLjQpO1xufVxuIiwiJGFwcEhlYWRlclpJbmRleDogODtcbiRjaGF0WkluZGV4OiA5O1xuJHNjcmVlbkJsb2NrWkluZGV4OiAxMDtcbiRkcmF3ZXJaSW5kZXg6IDExO1xuJG1vZGFsWkluZGV4OiAxMjtcbi8vIEVuYWJsZSBwb3BvdmVycyB0byBiZSBwbGFjZWQgaW5zaWRlIG9mIG1vZGFscyBhbmQgZHJhd2Vycy5cbiRwb3BvdmVyWkluZGV4OiAxMztcbiRub3RpZmljYXRpb25zWkluZGV4OiAxMDAwO1xuIiwiQGltcG9ydCBcIi4vdnVpL3N0eWxlVXRpbHMvX2NvbG9yc1wiO1xuQGltcG9ydCBcIi4vdnVpL3N0eWxlVXRpbHMvX2RlcHRoXCI7XG5AaW1wb3J0IFwiLi92dWkvY29tcG9uZW50cy9zY3JlZW5CbG9jay9pbmRleFwiO1xuXG4udnJzTW9kYWxXcmFwcGVyIHtcbiAgcG9zaXRpb246IGZpeGVkO1xufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
